module.exports = __webpack_public_path__ + "img/Зерно_Заволжья.abd3dcea.png";